// src/Components/AppealsPage.js
import React from 'react';

const AppealsPage = () => {
  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h2>Appeals</h2>
      <p>This is where users can view or submit appeals.</p>
      {/* 
        In the future, you can add forms or lists of appeals here.
      */}
    </div>
  );
};

export default AppealsPage;
